/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Created_On_WebInputs */

const en_plan_created_on_web = /** @type {(inputs: Plan_Created_On_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription was created on the web.`)
};

const es_plan_created_on_web = /** @type {(inputs: Plan_Created_On_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción se creó en la web.`)
};

/**
* | output |
* | --- |
* | "Your subscription was created on the web." |
*
* @param {Plan_Created_On_WebInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_created_on_web = /** @type {((inputs?: Plan_Created_On_WebInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Created_On_WebInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_created_on_web(inputs)
	return en_plan_created_on_web(inputs)
});